import { configureStore } from '@reduxjs/toolkit';
import userReducer from './features/user';
import advertiserReducer from './features/advertiser';

export const store = configureStore({
  reducer: {
    user: userReducer,
    advertiser: advertiserReducer
  }
})